import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";

// Consumer Routes
import { AppWrapper as ConsumerWrapper } from "../Consumer/Components/AppWrapper";
import { ChangePassword } from "../Consumer/Pages/Auth/ChangePassword";
import { ForgotPassword } from "../Consumer/Pages/Auth/ForgotPassword";
import { Login } from "../Consumer/Pages/Auth/Login";
import { NewPassword } from "../Consumer/Pages/Auth/NewPassword";
import { PasswordOTP } from "../Consumer/Pages/Auth/PasswordOTP";
import { PhoneOTP } from "../Consumer/Pages/Auth/PhoneOTP";
import { SignUp } from "../Consumer/Pages/Auth/SignUp";
import { BookAnAppointment } from "../Consumer/Pages/BookAnAppointment";
import { Cart } from "../Consumer/Pages/Cart";
import { Home } from "../Consumer/Pages/Home";
import { ConsumerIndex } from "../Consumer/Pages/Index";
import { ConsumerNewOrder } from "../Consumer/Pages/ConsumerNewOrder";
import LaundryService from "../Consumer/Pages/LaundryService";
import { MyOrders } from "../Consumer/Pages/MyOrders";
import { Notifications } from "../Consumer/Pages/Notifications";
import { NotificationsPermission } from "../Consumer/Pages/NotificationsPermission";
// import { OrderPlaced } from "../Consumer/Pages/OrderPlaced";
import { OrderReview } from "../Consumer/Pages/OrderReview";
import { OrdersHistory } from "../Consumer/Pages/OrdersHistory";
import { PaymentFail } from "../Consumer/Pages/PaymentFail";
import { PaymentSuccess } from "../Consumer/Pages/PaymentSuccess";
import { Profile } from "../Consumer/Pages/Profile";
import { ServiceReview } from "../Consumer/Pages/ServiceReview";
import { Summary } from "../Consumer/Pages/Summary";
import RouteProtector from "./RouteProtector";
import MyReferrals from "../Consumer/Pages/MyReferrals";
import NotesManagement from "../Consumer/Pages/NotesManagement";
import OrderDetailsRevamp from "../Consumer/Pages/OrderDetailsRevamp";
import OrdersHistoryRevamp from "../Consumer/Pages/OrdersHistoryRevamp";

// Admin Routes
import { Wrapper as AdminWrapper } from "../Admin/Components/Wrapper";
import { Login as AdminLogin } from "../Admin/Pages/Auth/Login";
import { Customers as AdminCustomers } from "../Admin/Pages/Customers";
import { CustomerAdd as AdminCustomerAdd } from "../Admin/Pages/Customers/Add";
import { CustomerView as AdminCustomerView } from "../Admin/Pages/Customers/View";
import { Dashboard as AdminDashboard } from "../Admin/Pages/Dashboard";
import { AdminIndex } from "../Admin/Pages/Index";
import { Orders as AdminOrders } from "../Admin/Pages/Orders";
import { OrderEdit as AdminOrderEdit } from "../Admin/Pages/Orders/Edit";
import { OrderReview as AdminOrderReview } from "../Admin/Pages/Orders/Review";
import { OrderSummary as AdminOrderSummary } from "../Admin/Pages/Orders/Summary";
import { OrderView as AdminOrderView } from "../Admin/Pages/Orders/View";

// Store Routes
import { BookRecurring } from "../Consumer/Pages/BookRecurring";
import DNPLOrders from "../Consumer/Pages/DNPLOrders";
import { ScheduledOrders } from "../Consumer/Pages/ScheduledOrders";
import Wallet from "../Consumer/Pages/Wallet";
import { Wrapper as StoreWrapper } from "../Store/Components/Wrapper";
import { Login as StoreLogin } from "../Store/Pages/Auth/Login";
import { Customers as StoreCustomers } from "../Store/Pages/Customers";
import { CustomerAdd as StoreCustomerAdd } from "../Store/Pages/Customers/Add";
import { OrderCreation as StoreOrderCreation } from "../Store/Pages/Customers/OrderCreation";
import { CustomerView as StoreCustomerView } from "../Store/Pages/Customers/View";
import { Dashboard as StoreDashboard } from "../Store/Pages/Dashboard";
import { StoreIndex } from "../Store/Pages/Index";
import { Orders as StoreOrders } from "../Store/Pages/Orders";
import { OrderAdd as StoreOrderAdd } from "../Store/Pages/Orders/Add/Add";
import { PreviewCart as StorePreviewCart } from "../Store/Pages/Orders/Add/PreviewCart";
import { OrderReview as StoreOrderAddReview } from "../Store/Pages/Orders/Add/Review";
import { OrderSummary as StoreOrderAddSummary } from "../Store/Pages/Orders/Add/Summary";
import { BookAnAppointment as StoreBookAnAppointment } from "../Store/Pages/Orders/BookAnAppointment";
import { OrderEdit as StoreOrderEdit } from "../Store/Pages/Orders/Edit/Edit";
import { OrderReview as StoreOrderEditReview } from "../Store/Pages/Orders/Edit/Review";
import { OrderSummary as StoreOrderEditSummary } from "../Store/Pages/Orders/Edit/Summary";
import { OrderView as StoreOrderView } from "../Store/Pages/Orders/View";
import { NewOrder as StoreNewOrder } from "../Store/Pages/Orders/NewOrder";

export const Router = () => {
  const role = useSelector((x) => x.Role)
  React.useEffect(() => {
    console.log(role);
  }, [role]);
  return (
    <>
      <Routes>
        {/* Consumer Routes */}
        {!role || role === "consumer" ? (
          <Route path="app" element={<ConsumerIndex />}>
            {/* Define Consumer Specific Routes */}
            <Route path="" element={<ConsumerWrapper />}>
              <Route index element={<Home />} />
              <Route path="services" element={<LaundryService />} />
              <Route
                path="book-an-appointment"
                element={<RouteProtector children={<BookAnAppointment />} />}
              />
              <Route
                path="setup-recurring"
                element={<RouteProtector children={<BookRecurring />} />}
              />
              <Route path="cart" element={<Cart />} />
              <Route path="new-order" element={<ConsumerNewOrder />} />
              <Route path="summary" element={<Summary />} />
              <Route
                path="order-review"
                element={<RouteProtector children={<OrderReview />} />}
              />
              <Route
                path="wallet"
                element={<RouteProtector children={<Wallet />} />}
              />
              <Route
                path="MyReferrals"
                element={<RouteProtector children={<MyReferrals />} />}
              />
              <Route
                path="notes-management"
                element={<RouteProtector children={<NotesManagement />} />}
              />
              <Route
                path="outstanding-orders"
                element={<RouteProtector children={<DNPLOrders />} />}
              />
              <Route
                path="order-placed/:id"
                element={
                  <RouteProtector
                    children={
                      // <OrderPlaced
                      <OrderDetailsRevamp
                        title="Order Booked"
                        subtitle="Your order has been booked!"
                      />
                    }
                  />
                }
              />
              <Route
                path="service-review"
                element={<RouteProtector children={<ServiceReview />} />}
              />
              <Route
                path="order-details/:id"
                element={
                  <RouteProtector
                    children={
                      // <OrderPlaced
                      <OrderDetailsRevamp
                        title="Order Details"
                        subtitle="Below are your order details."
                      />
                    }
                  />
                }
              />
              <Route
                path="order-canceled/:id"
                element={
                  <RouteProtector
                    children={
                      // <OrderPlaced
                      <OrderDetailsRevamp
                        title="Order Canceled"
                        subtitle="Your order has been canceled."
                      />
                    }
                  />
                }
              />
              <Route
                path="notifications"
                element={<RouteProtector children={<Notifications />} />}
              />
              <Route
                path="notifications-settings"
                element={
                  <RouteProtector children={<NotificationsPermission />} />
                }
              />
              <Route
                path="ongoing-orders"
                element={<RouteProtector children={<MyOrders />} />}
              />
              <Route
                path="scheduled-orders"
                element={<RouteProtector children={<ScheduledOrders />} />}
              />
              <Route
                path="orders-history"
                // element={<RouteProtector children={<OrdersHistory />} />}
                element={<RouteProtector children={<OrdersHistoryRevamp />} />}
              />
              <Route
                path="profile"
                element={<RouteProtector children={<Profile />} />}
              />
              <Route
                path="change-password"
                element={<RouteProtector children={<ChangePassword />} />}
              />
              <Route
                path="payment-successful"
                element={<RouteProtector children={<PaymentSuccess />} />}
              />
              <Route
                path="payment-failed"
                element={<RouteProtector children={<PaymentFail />} />}
              />
            </Route>
            <Route path="login" element={<Login />} />
            <Route path="sign-up" element={<SignUp />} />
            <Route path="phone-verification" element={<PhoneOTP />} />
            <Route path="password-verification" element={<PasswordOTP />} />
            <Route path="reset-password" element={<NewPassword />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
          </Route>
        ) : null}

        {/* Store Routes */}
        {!role || role === "store" ? (
          <Route path="store" element={<StoreIndex />}>
            <Route path="" element={<StoreWrapper />}>
              <Route index element={<StoreDashboard />} />
              <Route path="customers">
                <Route index element={<StoreCustomers />} />
                <Route
                  path="order-creation/:id"
                  element={<StoreOrderCreation />}
                />
                <Route path="view/:id" element={<StoreCustomerView />} />
                <Route path="add" element={<StoreCustomerAdd />} />
              </Route>
              <Route path="orders">
                <Route index element={<StoreOrders />} />
                <Route path="edit">
                  <Route path=":id" element={<StoreOrderEdit />} />
                  <Route
                    path="summary/:id"
                    element={<StoreOrderEditSummary />}
                  />
                  <Route path="review/:id" element={<StoreOrderEditReview />} />
                </Route>
                <Route path="add">
                  <Route path="" element={<StoreOrderAdd />} />
                  <Route path="summary" element={<StoreOrderAddSummary />} />
                  <Route path="review" element={<StoreOrderAddReview />} />
                  <Route path="preview-cart" element={<StorePreviewCart />} />
                </Route>
                <Route path="new" element={<StoreNewOrder />} />
                <Route
                  path="book-an-appointment"
                  element={<StoreBookAnAppointment />}
                />
                <Route path="view/:id" element={<StoreOrderView />} />
                <Route
                  path="success/:id"
                  element={
                    <StoreOrderView
                      title="Order Booked"
                      subtitle="Your order has been created successfully."
                    />
                  }
                />
              </Route>
            </Route>
            <Route path="auth">
              <Route path="login" element={<StoreLogin />} />
            </Route>
            <Route
              path="*"
              element={
                <Navigate
                  to={`${
                    !role ? "./auth/login" : role === "store" ? "./" : "/"
                  }`}
                />
              }
            />
          </Route>
        ) : null}

        {/* Admin Routes */}
        {!role || role === "admin" ? (
          <Route path="admin" element={<AdminIndex />}>
            <Route path="" element={<AdminWrapper />}>
              <Route index element={<AdminDashboard />} />
              <Route path="customers">
                <Route index element={<AdminCustomers />} />
                <Route path="view/:id" element={<AdminCustomerView />} />
                <Route path="add" element={<AdminCustomerAdd />} />
              </Route>
              <Route path="orders">
                <Route index element={<AdminOrders />} />
                <Route path="edit/:id" element={<AdminOrderEdit />} />
                <Route path="summary/:id" element={<AdminOrderSummary />} />
                <Route path="review/:id" element={<AdminOrderReview />} />
                <Route path="view/:id" element={<AdminOrderView />} />
              </Route>
            </Route>
            <Route path="auth">
              <Route path="login" element={<AdminLogin />} />
            </Route>
            <Route
              path="*"
              element={
                <Navigate
                  to={`${
                    !role ? "./auth/login" : role === "admin" ? "./" : "/"
                  }`}
                />
              }
            />
          </Route>
        ) : null}

        {/* Default Redirect */}
        <Route
          path="/"
          element={
            <Navigate to={`/${!role || role === "consumer" ? "app" : role}`} />
          }
        />
        <Route path="*" element={<Navigate to={`/`} />} />
      </Routes>
    </>
  );
};
